var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('loading-spinner',{attrs:{"show-spinner":_vm.isLoadingWarranties,"custom-class":"overlay fixed"}}),_vm._v(" "),_c('paginated-client-table',{attrs:{"title":_vm.title,"fields":_vm.tableColumns,"tableItems":_vm.localWarranties,"busy":_vm.isLoadingWarranties,"defaultPerPage":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }